/**
 * メールアドレスの形式を検証する。
 *
 * 画面（apps/admin）と API（apps/api）で判定がずれると、画面の検証を通った
 * アドレスが API で弾かれるため、両者でこの関数を使う
 */
export const isValidEmail = (value: string): boolean => {
  // JavaScript の `$` は（`m` フラグ無しでは）入力の末尾だけにマッチするため、
  // 末尾に改行や行区切り文字が付いた値はこの正規表現で弾かれる
  return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
};

/** メールアドレスの上限文字数（半角換算） */
export const MAX_EMAIL_LENGTH = 255;
